import { h } from 'preact';
import styled from 'styled-components';

interface LabelValueProps {
	id?: string;
	label: string;
	value: string;
}

const LabelWrapper = styled.div`
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid black;
	max-width: 100%;
	height: 66px;
	align-items: flex-end;
`

const Label = styled.label`
	font-family: 'Nunito Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 34px;
	width: 100px;
`

const Value = styled.label`
	font-family: 'Nunito Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 34px;
	width: 100px;
`

export const LabelValue = ({ id, label, value }: LabelValueProps) => {
	return (
		<LabelWrapper>
			<Label>{label}</Label>
			<Value>{value}</Value>
		</LabelWrapper>
	)
}
